<template>
    <v-flex xs12 md6 lg4>
        <router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: PARLIAMENTARIAN.item.PHID }}">
            <v-card color="grey lighten-5">
                <v-flex>
                    <v-layout>
                        <v-flex xs3>
                            <Portrait v-bind:PHID="PARLIAMENTARIAN.item.PHID"></Portrait>
                        </v-flex>
                        <v-flex xs9 class="d-flex">
                            <v-card-title primary-title class="justify-center">
                                <h2 class="title text-xs-center">{{ PARLIAMENTARIAN.item.DisplayName }}</h2>
                            </v-card-title>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-card>
        </router-link>
    </v-flex>
</template>

<script>
    import Portrait from '@/components/Portrait.vue'

    export default {

        props: {
            PARLIAMENTARIAN: {
                type: Object,
                required: true,
            }
        },

        components: {
            Portrait
        }
    }
</script>
<style scoped>
    a {
        color: #fff;
        text-decoration: none;
    }

    .v-card {
        height: 100%;
    }
</style>
